import { TranslationsContext } from '@teliaee/telia-translate';
import React, { useContext } from 'react';
import { Item } from './types';

interface InternetPacketPriceProps {
  item: Item;
}

const InternetPacketPrice: React.FC<InternetPacketPriceProps> = (props) => {
  const { translate } = useContext(TranslationsContext);
  const { item } = props;
  const {
    pricePerMonth: { value, label, originalPrice, struckPrice }
  } = item;

  return (
    <React.Fragment>
      {translate('internetPacketItem.pricePerMonth')}
      <p className="h4 text-bold">{`${value} ${label}`}</p>
      {originalPrice && (
        <p className="text-small text-light">
          {originalPrice}
          {struckPrice && <span style={{ textDecoration: 'line-through' }}>{struckPrice}</span>}
        </p>
      )}
    </React.Fragment>
  );
};

export default InternetPacketPrice;
